import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveUser } from "../../services/userService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";

class UserForm extends Form {
  state = {
    data: {
      name: "",
      email: "",
      password: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Name"),
    email: Joi.string().required().label("Email"),
    password: Joi.string().required().label("Password"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveUser(this.state.data, "cashier");
      toast.success("User has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/users");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.email)
          errors.email = ex.response.data.errors.email;

        if (ex.response.data.errors.password)
          errors.password = ex.response.data.errors.password;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/users.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add user</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/users")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add user</h3>
              <p>Provide the information below to add the user.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("email", "Email", "text")}
              {this.renderInput("password", "Password", "password")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default UserForm;
